import { SortOrder } from '@/model/common';

export interface QueryParams {
  'sort[field]': string;
  'sort[sort]': SortOrder;
  'pagination[page]': string;
  limit: string;
}

export const GetParams = (filter: any, pageNumber = 0, pageSize = 10, sortOrder = 'asc', sortField = ''): URLSearchParams => {
  const params = new URLSearchParams(filter);
  params.set('sort[field]', sortField);
  params.set('sort[sort]', sortOrder);
  params.set('pagination[page]', String(pageNumber));
  params.set('limit', String(pageSize));
  return params;
};

export const GetParamsObject = (filter: any, pageNumber = 0, pageSize = 10, sortOrder = 'asc', sortField = ''): QueryParams => {
  const params: QueryParams = {
    ...(filter || {}),
    'sort[field]': sortField,
    'sort[sort]': sortOrder,
    'pagination[page]': String(pageNumber),
    limit: String(pageSize),
  };
  return params;
};
